import React, { useEffect, useState } from "react";
import { Flex } from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import { appRoutes } from "../../../App";
import {
  AppHeader,
  AppHeaderHeight,
} from "../../shared/views/AppHeader/AppHeader";
import { LoadingScreen } from "../../shared/views/LoadingScreen/LoadingScreen";
import { CraWayApi } from "../services/CraWayApi";
import { ErrorScreen } from "../../shared/views/ErrorScreen/ErrorScreen";

export const CraWayRedirectPage: React.FC = () => {
  const craWayId = useParams().craWayId!;

  const [showError, setShowError] = useState(false);
  const navigate = useNavigate();

  const loadContextAndRedirect = async () => {
    const craWay = await CraWayApi.get(craWayId).then((r) => r.data);

    const urlParams = new URLSearchParams();
    urlParams.append("craWayId", craWay.id);

    navigate(`${appRoutes.survey(craWay.surveyId)}?${urlParams.toString()}`);
  };

  useEffect(() => {
    loadContextAndRedirect().catch(() => {
      setShowError(true);
    });
    // eslint-disable-next-line
  }, []);

  return (
    <Flex flexDir="column" maxHeight="100vh" flexGrow={1} position="relative">
      <AppHeader />
      <AppHeaderHeight />

      {showError ? <ErrorScreen errorCode={404} /> : <LoadingScreen />}
    </Flex>
  );
};
